<template>
  <v-col cols="12" lg="2" class="sticky-sidebar">
    <template v-if="!$vuetify.breakpoint.lgAndDown">
      <v-list
        class="pt-0 sticky-sidebar__item"
        :style="`${
          $vuetify.breakpoint.width < 1400 ? 'max-width: 163px' : null
        }`"
      >
        <v-list-item-group
          color="primary"
          class="d-flex flex-row flex-lg-column justify-start"
        >
          <v-list-item
            v-for="page of pages"
            :key="page.key"
            :active-class="'elevation-4--before'"
            :ripple="false"
            :to="page.route"
          >
            <v-list-item-content>
              <v-list-item-title class="p-2">
                {{ page.label }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </template>
    <template v-else>
      <v-tabs
        :class="$vuetify.breakpoint.mobile ? 'mt-4' : ''"
        center-active
        class="pt-0 d-flex flex-row flex-lg-column justify-start"
        style="overflow: hidden; padding: 8px 8px!important;"
      >
        <v-tab
          v-for="page of pages"
          :key="page.key"
          :active-class="$vuetify.breakpoint.lgAndDown ? '' : 'elevation-2'"
          class=""
          :ripple="false"
          :to="page.route"
          style="min-width: unset!important;"
        >
          <span class="p-2">{{ page.label }}</span>
        </v-tab>
      </v-tabs>
    </template>
  </v-col>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      pages: [
        {
          key: "users",
          label: this.$t("heading.reseller.page.users"),
          route: "/reseller-area/users",
        },
        {
          key: "branding",
          label: this.$t("heading.reseller.page.branding"),
          route: "/reseller-area/branding",
        },
        {
          key: "email-settings",
          label: this.$t("heading.reseller.page.emailSettings"),
          route: "/reseller-area/email-settings",
        },
        {
          key: "logs",
          label: this.$t("heading.reseller.page.logs"),
          route: "/reseller-area/logs",
        },
        {
          key: "api",
          label: this.$t("heading.reseller.page.api"),
          route: "/reseller-area/api",
        },
      ],
    };
  },
  methods: {},
  computed: {},
};
</script>

<style src="../../components/HostingPagesSidebar.scss" lang="scss" scoped />
